<template>
  <div
    class="content"
    :class="!isUle?'headStyle':''"
    id="scroll2"
    ref="content"
    :style="{'height':scrollHeight}"
  >
    <!-- <h5-header v-if="!isUle" :class="!isUle?'h5headStyle':''"></h5-header> -->
    <download-head v-if="!isUle&&!isUcbank"></download-head>
    <header>
      <img class="head-bgImg" v-for="item in headImgArr" :src="item" :key="item" alt />
      <div class="preheat-active">
        <img src="../../assets/images/preheat_one.png" alt />
        <img src="../../assets/images/preheat_two.png" alt />
      </div>
      <img class="header-title" src="../../assets/images/preheat_head.png" alt />
      <head-animation></head-animation>
    </header>
    <nav-menu
      :scrollTop="scrollTop"
      :showMenuIndex="showMenuIndex"
      :navBarShow="navBarShow"
      :type="0"
      :navMain="navMain"
    ></nav-menu>
    <div class="main" v-if="showMain">
      <div class="cj-main" id="xdydj">
        <img
          class="cj-header"
          src="//i0.ulecdn.com/i/event/2019/0919/main/images/cj_header.png"
          alt
        />
        <div class="rule-icon2" data-stat="下单抽奖-查看规则" @click="dwRecommond(2002,'xdydj')"></div>
        <div class="cj-con">
          <img
            class="rule-icon"
            src="//i0.ulecdn.com/i/event/2019/0919/main/images/rule_icon.png"
            alt
          />
          <img class="cj-bg" src="//i0.ulecdn.com/i/event/2019/0919/main/images/cj_bg.png" alt />
          <img class="cj-btn" src="//i0.ulecdn.com/i/event/2019/0919/main/images/cj_btn.png" alt />
          <img class="shou" src="//i0.ulecdn.com/i/event/2019/0919/main/images/shou.png" alt />
          <div class="cj-text">
            最高
            <span>888</span>元超级红包
            <br />8月30日即将开始
          </div>
        </div>
      </div>
      <div class="qd-main" id="ttqd">
        <img
          class="qd-header"
          src="//i0.ulecdn.com/i/event/2019/0919/main/images/qd_header.png"
          alt
        />
        <div class="rule-icon2" data-stat="天天签到-查看规则" @click="dwRecommond(2002,'ttqd')"></div>
        <div class="qd-con backgroundImgtwo">
          <img
            class="rule-icon"
            src="//i0.ulecdn.com/i/event/2019/0919/main/images/rule_icon.png"
            alt
          />
          <img
            v-show="isSign"
            class="qd-label"
            src="//i0.ulecdn.com/i/event/2019/0919/main/images/qd_label.png"
            alt
          />
          <img class="qd-btn" :src="signBtn.activeBtn" @click="toGetCoupue" alt />
        </div>
      </div>
      <div class="list-main" id="tgjsh" v-show="tgjshList&&tgjshList.length>0">
        <img
          class="list-header"
          src="//i0.ulecdn.com/i/event/2019/0919/main/images/tg_header.png"
          alt
        />
        <img
          class="more-btn"
          @click="toOthers('https://www.ule.com/event/activity/20180331/group/index.html')"
          src="//i0.ulecdn.com/i/event/2019/0919/main/images/more_btn.png"
          alt
        />
        <con-list :list="tgjshList" :type="2" :isStart="true"></con-list>
      </div>
      <div class="list-main" id="ylswh" v-show="ylswhList&&ylswhList.length>0">
        <img
          class="list-header"
          src="//i0.ulecdn.com/i/event/2019/0919/main/images/35_header.png"
          alt
        />
        <img
          class="more-btn"
          @click="toOthers('https://www.ule.com/event/2019/0614/35h/index.html')"
          src="//i0.ulecdn.com/i/event/2019/0919/main/images/more_btn.png"
          alt
        />
        <con-list :list="ylswhList" :type="3" :isStart="true"></con-list>
      </div>
      <div class="list-main" id="yczq" v-show="yczqList&&yczqList.length>0">
        <img
          class="list-header"
          src="//i0.ulecdn.com/i/event/2019/0919/main/images/yc_header.png"
          alt
        />
        <img
          class="more-btn"
          @click="toOthers('https://www.ule.com/event/2019/0812/H5.html?adid=psbc_yl_appzhc')"
          src="//i0.ulecdn.com/i/event/2019/0919/main/images/more_btn.png"
          alt
        />
        <con-list :list="yczqList" :type="4" :isStart="true"></con-list>
      </div>
      <div class="list-main" id="wntj" v-show="wntjList&&wntjList.length>0">
        <img
          class="list-header"
          src="//i0.ulecdn.com/i/event/2019/0919/main/images/tj_header.png"
          alt
        />
        <con-list :list="wntjList" :type="5" :isStart="true"></con-list>
      </div>
    </div>
    <slider-menu :type="0"></slider-menu>
    <rule-alert @isRuleAlert="isRuleAlert" v-if="isShowRule" :ruleText="ruleText"></rule-alert>
    <tab-bar :type="0"></tab-bar>
  </div>
</template>

<script>
import Vue from "vue";
import navMenu from "../common/navMenu";
import conList from "../common/list";
import sliderMenu from "../common/sliderMenu";
import hbAlert from "../common/alert";
import headAnimation from "../common/animation";
import cjAlert from "../common/cjAlert";
import downloadHead from "../common/downloadHead";
import h5Header from "../common/head";
import ruleAlert from "../common/ruleAlert";
import tabBar from "../common/tabBar";
import { Toast } from "mint-ui";
import * as URL from "../../assets/js/url.js";
export default {
  props: ["initSystemTime", "isUcbank"],
  data() {
    return {
      showMain: false,
      scrollHeight: document.documentElement.clientHeight + "px",
      headImgArr: [
        "//i0.ulecdn.com/i/event/2019/0919/main/images/H5_01.jpg?v=1",
        "//i0.ulecdn.com/i/event/2019/0919/main/images/H5_02.jpg?v=1",
        "//i0.ulecdn.com/i/event/2019/0919/main/images/H5_03.jpg?v=1",
        "//i0.ulecdn.com/i/event/2019/0919/main/images/H5_04.jpg?v=1",
        "//i0.ulecdn.com/i/event/2019/0919/main/images/H5_05.jpg?v=1",
        "//i0.ulecdn.com/i/event/2019/0919/main/images/H5_06.jpg?v=1",
        "//i0.ulecdn.com/i/event/2019/0919/main/images/H5_07.jpg?v=1",
        "//i0.ulecdn.com/i/event/2019/0919/main/images/H5_08.jpg?v=1",
        "//i0.ulecdn.com/i/event/2019/0919/main/images/H5_09.jpg?v=1",
        "//i0.ulecdn.com/i/event/2019/0919/main/images/H5_10.jpg?v=1",
        "//i0.ulecdn.com/i/event/2019/0919/main/images/H5_11.jpg?v=1"
      ],
      signedTimes: 0, //已签到次数
      isSign: false, //当天是否已签到
      isShowHeader: false,
      scrollTop: 0, //滚动条位置
      showMenuIndex: 1, //默认激活第一个菜单
      isUle: false, //是否app客户端环境
      signBtn: {
        //签到按钮
        activeBtn: require("../../assets/images/signed.png"),
        disableBtn: require("../../assets/images/axc_disable_btn.png")
      },
      apiCode: [], //广告推荐位,天天签到、下单赢大奖
      betaApiCode: ["event_2019919_qd_rule", "event_2019919_prize_rule"], //广告推荐位,天天签到、下单赢大奖
      prdApiCode: ["event_2019919_qd_rule", "event_2019919_prize_rule"], //广告推荐位,天天签到、下单赢大奖
      betaModuleKeys: [
        "919_np_zhutui",
        "event_2019919_03",
        "event_2019919_04",
        "event_2019919_05",
        "event_2019919_06"
      ],
      prdModuleKeys: [
        "event_2019919_fanli_01",
        "event_2019919_03",
        "event_2019919_04",
        "event_2019919_05",
        "event_2019919_06"
      ],
      moduleKeys: [], //普通商品推荐位

      cjflList: [], //超级返利数据列表
      tgjshList: [], //团购聚实惠数据列表
      ylswhList: [], //邮乐三五惠数据列表
      yczqList: [], //邮储专区数据列表
      wntjList: [], //为您推荐数据列表
      isShowRule: false,
      ruleText: "", //规则
      isLogin: false, //用户登录状态
      navBarShow: [1, 1, 1, 1, 1], //1显示0隐藏
      navMain: [
        {
          id: "xdydj",
          name: "下单赢大奖"
        },
        {
          id: "ttqd",
          name: "天天签到"
        },
        {
          id: "tgjsh",
          name: "团购聚实惠"
        },
        {
          id: "ylswh",
          name: "邮乐三五惠"
        },
        {
          id: "yczq",
          name: "邮储专区"
        },
        {
          id: "wntj",
          name: "为您推荐"
        }
      ]
    };
  },
  created() {
    this.isUle = this.BASE.$browser().ule;
    this.initCode();
    this.dwRecommond(2001); //普通商品推荐位
    setTimeout(() => {
      this.showMain = true;
    }, 100);
  },
  mounted() {
    // 绑定监听事件
    // window.addEventListener("scroll", this.handleScroll, true);
    document
      .getElementById("scroll2")
      .addEventListener("scroll", this.handleScroll, true);
  },
  methods: {
    toGetCoupue() {
      if (!this.isUle) {
        this.BASE.openApp();
        return;
      }
      location.href =
        "https://www." + URL.doMain + "/ulewap/coupon_center.html?from=919H5";
    },
    initCode() {
      if (process.env.NODE_ENV == "production") {
        //生产环境
        this.apiCode = this.prdApiCode;
        this.moduleKeys = this.prdModuleKeys;
      } else {
        //beta环境
        this.apiCode = this.betaApiCode;
        this.moduleKeys = this.betaModuleKeys;
      }
    },
    toOthers(link) {
      location.href = link;
    },
    isRuleAlert(data) {
      this.isShowRule = data;
    },
    dwRecommond(type, flag) {
      let path, jsonpCallback;
      if (type == 2002) {
        //广告推荐位
        jsonpCallback = "jsonp31";
        path =
          jsonpCallback +
          "/" +
          type +
          "/0/" +
          this.apiCode.join("-") +
          "/" +
          this.apiCode.join("-") +
          ".html";
      } else {
        //普通商品推荐位
        jsonpCallback = "jsonp32";
        path =
          jsonpCallback +
          "/" +
          type +
          "/0/" +
          this.moduleKeys.join("-") +
          "/" +
          this.moduleKeys.join("-") +
          ".html";
      }
      this.HTTP.dwRecommond(path, jsonpCallback)
        .then(res => {
          if (type == 2002) {
            this.initRule(res, flag); //活动规则
          } else if (type == 2001) {
            this.initList(res, this.moduleKeys); //商品列表
          }
        })
        .catch(err => {
          let jsonData = require("../../assets/js/dwRecommond.json");
          let dwRecommondData = localStorage.dwRecommondData
            ? JSON.parse(localStorage.dwRecommondData)
            : jsonData;
          this.initList(dwRecommondData, this.moduleKeys); //商品列表
        });
    },
    initRule(res, flag) {
      this.isShowRule = true;
      this.ruleText = "";
      if (flag == "ttqd") {
        //天天签到规则
        for (let i = 0; i < res[this.apiCode[0]].length; i++) {
          this.ruleText =
            this.ruleText + "<p>" + res[this.apiCode[0]][i].title + "</p>";
        }
      } else if (flag == "xdydj") {
        //下单赢大奖规则
        for (let i = 0; i < res[this.apiCode[1]].length; i++) {
          this.ruleText =
            this.ruleText + res[this.apiCode[1]][i].title + "<br />";
        }
      }
    },
    initList(res, moduleKeys) {
      let tgData = res[moduleKeys[1]],
        newTgData = [];
      for (let i = 0; i < tgData.length; i++) {
        if (JSON.parse(tgData[i].promotionDesc)) {
          let groupPrice = JSON.parse(tgData[i].promotionDesc).rules[0]
            .groupbuyPrice;
          tgData[i].groupbuyPrice = groupPrice;
        }
        newTgData.push(tgData[i]);
      }
      this.tgjshList = newTgData; //团购聚实惠数据列表

      let skillData = res[moduleKeys[2]],
        newSkillData = [];
      for (let i = 0; i < skillData.length; i++) {
        if (JSON.parse(skillData[i].promotionDescTwo)) {
          let skillPrice = JSON.parse(skillData[i].promotionDescTwo)
            .listingSeckillPrice;
          skillData[i].skillPrice = skillPrice;
        }
        newSkillData.push(skillData[i]);
      }
      this.ylswhList = newSkillData; //邮乐三五惠数据列表
      this.yczqList = res[moduleKeys[3]]; //邮储专区数据列表
      this.wntjList = res[moduleKeys[4]]; //为您推荐数据列表

      if (!this.tgjshList) {
        this.navBarShow[1] = 0;
      }
      if (!this.ylswhList) {
        this.navBarShow[2] = 0;
      }
      if (!this.yczqList) {
        this.navBarShow[3] = 0;
      }
      if (!this.wntjList) {
        this.navBarShow[4] = 0;
      }
    },
    handleScroll(data) {
      this.$nextTick(() => {
        this.scrollTop = this.$refs.content.scrollTop;
        // this.$refs.content.scrollTop = 200;
        let height;
        if (this.isUle) {
          height = 45;
        } else {
          height = 85;
        }
        //获取各个楼层的滚动条高度并存储
        let offsetTopArr = [];
        if (offsetTopArr.length < 1 || !offsetTopArr) {
          //避免每一次滚动都重新获取元素位置数据
          for (let i = 0; i < this.navMain.length; i++) {
            let thisScroll =
              document.getElementById(this.navMain[i].id).offsetTop - height;
            offsetTopArr.push(thisScroll);
          }
        }
        this.showMenuIndex = this.BASE.navMenuIndex(
          this.scrollTop,
          offsetTopArr
        );
      });
    },
    indexValue(val, arr) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] == val) {
          return i;
        }
      }
    }
  },
  destroyed() {
    // 销毁绑定
    window.removeEventListener("scroll", this.handleScroll);
  },
  components: {
    navMenu,
    conList,
    sliderMenu,
    headAnimation,
    downloadHead,
    h5Header,
    ruleAlert,
    tabBar
  }
};
</script>

<style lang="less" scoped>
.headStyle {
  padding-top: 40px;
}
//隐藏滚动条
.content::-webkit-scrollbar {
  display: none;
  width: 0px;
}
.content {
  overflow-y: scroll;
  box-sizing: border-box;
  padding-bottom: 1.7rem;
  over-flow: auto; /* winphone8和android4+ */
  -webkit-overflow-scrolling: touch; /* ios5+ */

  header {
    position: relative;
    overflow: hidden;
    min-height: 70vh;
    .head-bgImg {
      display: block;
      width: 100%;
      float: left;
      font-size: 0;
      // margin-top: -1px;
    }
    .header-title {
      position: absolute;
      top: 8%;
      z-index: 4;
      width: 76%;
      left: 12%;
    }
    .preheat-active {
      width: 100%;
      box-sizing: border-box;
      padding: 0 0.2rem;
      position: absolute;
      bottom: 0.1rem;
      z-index: 3;
      overflow: hidden;
      img {
        display: block;
        width: 100%;
        float: left;
        font-size: 0;
      }
    }
    .activites {
      overflow: hidden;
      box-sizing: border-box;
      padding: 0 0.2rem;
      width: 100%;
      position: absolute;
      bottom: 0.1rem;
      z-index: 3;

      .activites-bg {
        width: 49%;
        height: 2.9rem;
        position: relative;
      }
      .hbx-main {
        background: url("//i0.ulecdn.com/i/event/2019/0919/main/images/hby_bg.png")
          no-repeat;
        background-size: 100% 100%;
        float: left;
      }
      .axc-main {
        background: url("//i0.ulecdn.com/i/event/2019/0919/main/images/axc_bg.png")
          no-repeat;
        background-size: 100% 100%;
        float: right;
      }
      img {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 86%;
        position: absolute;
        bottom: 0.3rem;
        left: 7%;
      }
    }
  }
  .main {
    background: #ff4900;
    .qd-main {
      box-sizing: border-box;
      padding: 0 0.2rem;
      position: relative;
      .qd-header {
        width: 100%;
        position: relative;
        z-index: 3;
      }
      .rule-icon2 {
        position: absolute;
        top: 1.6rem;
        right: 0.26rem;
        height: 0.76rem;
        width: 0.8rem;
        z-index: 5;
      }
      .qd-con {
        position: relative;
        box-sizing: border-box;
        width: 100%;
        height: 2rem;
        border-left: 0.1rem solid #cb3d17;
        border-right: 0.1rem solid #cb3d17;
        border-bottom: 0.1rem solid #cb3d17;
        border-radius: 0.16rem;
        z-index: 0;
        margin-top: -0.4rem;
        background-color: #f3b44f;
        .rule-icon {
          position: absolute;
          top: 0;
          right: 0;
          height: 0.76rem;
          width: auto;
          z-index: 2;
        }

        .qd-label {
          position: absolute;
          left: 0;
          top: 0;
          width: 1.1rem;
          z-index: 0;
        }
        .times-con {
          width: 5.4rem;
          height: 0.6rem;
          margin: 0 auto;
          padding-top: 0.3rem;
          position: relative;
          img {
            width: 100%;
          }
          p {
            font-size: 0.44rem;
            color: #c81000;
            font-family: Arial-BoldMT;
            position: absolute;
            top: 0.4rem;
            right: 2rem;
            font-weight: bold;
          }
        }
        .qd-text {
          font-size: 0.22rem;
          color: #7a4f09;
          text-align: center;
          margin-top: 0.2rem;
        }
        .qd-times {
          position: relative;
          margin: 0.85rem auto 0;
          // overflow: hidden;
          width: 85%;
          // padding-left: 0.7rem;
          // padding-top: 0.35rem;
          height: 0.3rem;
          background: url("//i0.ulecdn.com/i/event/2019/0919/main/images/jindu_bg.png")
            no-repeat;
          background-size: 100% 100%;
          // display: flex;
          // justify-content: space-between;
          .times-item {
            // min-height: 0.38rem;
            position: relative;
            // float: left;
            // margin-left: -0.1rem;
            display: block;
            float: left;
            width: 49%;
            height: 0.3rem;
            p {
              color: #aa5e03;
              font-size: 0.24rem;
              clear: both;
              margin-bottom: 0.2rem;
              margin-left: -0.16rem;
              height: 0.25rem;
              .qd-hb {
                width: auto;
                height: 0.8rem;
                position: absolute;
                top: -0.3rem;
                right: 0.3rem;
                z-index: 4;
              }
            }
            .point {
              position: absolute;
              width: auto;
              height: 0.38rem;
              z-index: 3;
              left: -0.16rem;
              top: -0.045rem;
            }
            .point-two {
              right: -0.16rem;
              left: auto;
            }
            .pointThree {
              left: -0.36rem;
            }
            .times-line {
              display: block;
              height: 0.2rem;
              position: relative;
              z-index: 0;
              margin-top: 0.04rem;
            }
          }
          .get-hb {
            width: 1.1rem;
            height: 0.8rem;
            position: absolute;
            right: -0.45rem;
            top: -0.8rem;
          }
        }
        .qd-btn {
          width: 4.4rem;
          height: 1rem;
          margin: 0 auto 0;
          padding-top: 0.6rem;
        }
      }
    }
    .cj-main {
      box-sizing: border-box;
      position: relative;
      .cj-header {
        width: 88%;
        position: relative;
        z-index: 3;
        margin: 0 auto;
      }
      .rule-icon2 {
        position: absolute;
        top: 1.5rem;
        right: 0.4rem;
        height: 0.76rem;
        width: 0.8rem;
        z-index: 5;
      }
      .cj-con {
        width: 100%;
        height: 3rem;
        position: relative;
        z-index: 0;
        margin-top: -0.4rem;
        .rule-icon {
          position: absolute;
          top: 0;
          right: 0.4rem;
          height: 0.76rem;
          width: auto;
          z-index: 2;
        }

        .cj-bg {
          width: 100%;
        }
        .cj-btn {
          width: 35%;
          position: absolute;
          // top: 33%;
          left: 11%;
          bottom: 0.66rem;
        }
        .cj-btn-two {
          height: 1.2rem;
        }
        .shou {
          position: absolute;
          left: 2.7rem;
          bottom: 0.7rem;
          width: 0.85rem;
          height: auto;
        }

        .cj-text {
          position: absolute;
          top: 32%;
          right: 12%;
          font-size: 0.26rem;
          font-weight: bold;
          color: #ffe4b8;
          line-height: 1.3;
          text-align: center;
          span {
            color: #ffe400;
            font-size: 0.46rem;
            font-family: Arial-BoldMT;
          }
        }
      }
    }
    .list-main {
      position: relative;
      padding: 0 0.2rem;
      .list-header {
        width: 100%;
        position: relative;
        z-index: 3;
      }
      .list-con {
        min-height: 3rem;
        position: relative;
        box-sizing: border-box;
        width: 100%;
        // height: 4rem;
        border-left: 0.1rem solid #cb3d17;
        border-right: 0.1rem solid #cb3d17;
        border-bottom: 0.1rem solid #cb3d17;
        border-radius: 0.16rem;
        z-index: 0;
        margin-top: -0.5rem;
        background-color: #f1ca8f;
        padding: 0.5rem 0.1rem 0;
        ul {
          width: 100%;
          overflow: hidden;
          li {
            width: 49%;
            background-color: #fff;
            float: left;
            position: relative;
            border-radius: 0.2rem;
            overflow: hidden;
            margin-bottom: 0.2rem;
            .img {
              width: 100%;
              display: block;
              position: relative;
              padding-top: 100%;
              img {
                position: absolute;
                left: 0;
                top: 0;
                height: 100%;
                width: 100%;
                display: block;
              }
            }
            h5 {
              white-space: normal;
              font-size: 0.22rem;
              color: #333;
              padding: 0.1rem 0.2rem 0;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              height: 0.672rem;
              line-height: 1.4;
              font-family: "Microsoft YaHei";
            }
            p {
              padding: 0.3rem 0.2rem 0;
              font-size: 0.24rem;
              color: #ee0000;
              margin-bottom: 0.2rem;
              font-family: "Arial";
              position: relative;
              span {
                font-size: 0.3rem;
              }
              .shouy {
                position: absolute;
                right: 0.2rem;
                font-size: 0.18rem;
                height: 0.35rem;
                line-height: 0.35rem;
                border-radius: 0.2rem 0 0 0.2rem;
                padding: 0 0.1rem;
                background-color: #ff8a00;
                color: #fff;
              }
            }
            .but {
              display: block;
              text-align: center;
              img {
                display: inline-block;
                width: 3.08rem;
              }
            }
            .but_go {
              display: block;
              text-align: center;
              height: 0.72rem;
              position: relative;
              padding: 0 0.3rem 0.2rem;
              box-sizing: border-box;
              span {
                box-sizing: border-box;
                width: 100%;
                height: 0.5rem;
                color: #fff;
                font-size: 0.24rem;
                text-align: center;
                line-height: 0.5rem;
                background: linear-gradient(95deg, #fd2618 0%, #fb5315 100%);
                margin: 0 auto;
                display: block;
                border-radius: 0.26rem;
              }
            }
          }
          li:nth-of-type(2n) {
            float: right;
          }
        }
      }
      .more-btn {
        display: block;
        width: 18%;
        position: absolute;
        top: 1.4rem;
        left: 50%;
        margin-left: -9%;
        z-index: 4;
      }
    }
  }
}
.backgroundImgtwo {
  background: url("//i0.ulecdn.com/i/event/2019/0919/main/images/bg_twomax.png")
    repeat-y;
  background-size: 100% 100%;
}
.backgroundImg {
  background: url("//i0.ulecdn.com/i/event/2019/0919/main/images/bg-gloab.png")
    repeat-y;
  background-size: 100% auto;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/preheat.vue